import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { isBhiAdmin } from 'src/helpers/permissions';
import { useAdminCompaniesApi } from '../api';
import { useUserCompaniesService } from '../services';
import { setCurrentAdminCompany } from '../slices';
import { AdminCompany } from '../types';
import { selectProfile } from 'src/modules/profile/slices';

export const useEditCompanyViewController = () => {
  const dispatch = useDispatch();
  const { profile } = useSelector(selectProfile);
  const [company, setCompany] = useState<AdminCompany>();
  const { companyId, tab: urlTab } = useParams();
  const navigate = useNavigate();
  const [tab, setTab] = useState(urlTab || 'info');
  const { getAdminCompany } = useAdminCompaniesApi();
  const { getCompanies } = useUserCompaniesService();

  const refreshCompany = useCallback(async () => {
    if (!companyId) {
      return;
    }

    await getCompanies();
    const response = await getAdminCompany(companyId);
    setCompany(response.data);
    dispatch(setCurrentAdminCompany(response.data));
  }, [companyId, dispatch, getAdminCompany, getCompanies]);

  useEffect(() => {
    void refreshCompany();
  }, [refreshCompany]);

  useEffect(() => {
    if (urlTab && urlTab !== tab) {
      setTab(urlTab);
    }
  }, [urlTab, tab]);

  const handleTabChange = (_event: React.SyntheticEvent, newTab: string) => {
    setTab(newTab);
    navigate(`/admin/companies/edit/${companyId}/${newTab}`);
  };

  return {
    profile,
    company,
    tab,
    isAllowed: isBhiAdmin(profile),
    refreshCompany,
    handleTabChange,
  };
};
